/**
 * @fileoverview 브라우저 인코딩/디코딩 유틸리티
 *
 * Base64 기반 문자열 인코딩/디코딩을 제공합니다.
 * 브라우저의 btoa/atob API를 사용하며, URL-safe 인코딩을 지원합니다.
 */

/**
 * Base64 기반 문자열 암호화/복호화 유틸리티
 *
 * @example
 * encrypt.encode('hello'); // 'aGVsbG8='
 * encrypt.decode('aGVsbG8='); // 'hello'
 * encrypt.decode('eyJuYW1lIjoiSm9obiJ9', true); // { name: 'John' }
 */
export const encrypt = {
  /**
   * 문자열을 Base64로 인코딩하고 URL-safe하게 변환
   * @param val - 인코딩할 문자열
   * @returns URL-safe Base64 인코딩된 문자열
   */
  encode: (val: string) => encodeURIComponent(btoa(val)),
  /**
   * Base64로 인코딩된 문자열을 디코딩
   * @param val - 디코딩할 Base64 문자열
   * @param isJson - JSON 파싱 여부 (기본값: false)
   * @returns 디코딩된 문자열 또는 JSON 객체 (isJson이 true인 경우)
   */
  decode: (val: string, isJson: boolean = false) => {
    if (isJson) {
      try {
        return JSON.parse(atob(decodeURIComponent(val)));
      } catch {
        return '';
      }
    } else {
      return atob(decodeURIComponent(val));
    }
  },
};
